import { render, staticRenderFns } from "./PageNotReady.vue?vue&type=template&id=5da09756&"
import script from "./PageNotReady.vue?vue&type=script&lang=js&"
export * from "./PageNotReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports